import React, {Component} from 'react'
import {Loader, Modal} from 'rsuite'

import {StyledButton, StyledConfirmModal} from '../styled/StyledQuestionComponents'
import AlertConfirmIcon from './Icons/AlertConfirmIcon'


class ModalConfirmSendAnswers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            loading: false
        }

    }

    render() {
        return (
            <div className="modal-container">
                <StyledConfirmModal backdrop="static" show={this.props.showConfirmModal}
                                    onHide={() => this.props.closeConfirmModal()} size='xs'>
                    <Modal.Body>
                        <div className={'modal-body'}>
                            <AlertConfirmIcon
                                width={60}
                            />
                            <p> Você finalizou o questionário. Deseja enviar as respostas? </p>
                            <p>Uma vez enviada você<strong> não poderá alterar</strong> <br/> as respostas para essa
                                tentativa</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className={'modal-footer'}>
                            <StyledButton
                                color={'green'}
                                appearance="defaut"
                                disable={this.state.loading}
                                loading={this.state.loading}
                                onClick={() => {
                                    this.setState({loading: true})
                                    this.props.sendAnswers()
                                }}>
                                Enviar tudo e finalizar
                            </StyledButton>
                            <StyledButton
                                appearance="ghost"
                                disable={this.state.loading}
                                onClick={() => this.props.closeConfirmModal()}>
                                Cancerlar
                            </StyledButton>
                        </div>
                    </Modal.Footer>
                </StyledConfirmModal>
            </div>
        )
    }
}

export default ModalConfirmSendAnswers



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/ModalConfirmSendAnswers.js